import { all } from "redux-saga/effects";

import AlertSaga from "./Alerts/saga";
import AuthSagas from "./Auth/saga";
import BlogsSaga from "./Blogs/saga";
import BundlesSaga from "./Bundles/saga";
import CareHomeGroupsSaga from "./CareHomeGroups/saga";
import CarePlanTeamSaga from "./CarePlanTeam/saga";
import CarePlanTaskSaga from "./CarePlanTask/saga";
import CarePlanEquipmentSaga from "./CarePlanEquipment/saga";
import ResidentGroupSaga from "./ResidentGroup/saga";
import CareRoundSaga from "./CareRound/saga";
import CareRoundTypeSaga from "./CareRoundType/saga";
import ContactSaga from "./Contacts/saga";
import SettingsSaga from "./EmailSettings/saga";
import EnquiriesSaga from "./Enquiries/saga";
import FaqsSaga from "./Faqs/saga";
import HistorySaga from "./History/saga";
import HomeGroupsAdminSaga from "./HomeGroupsAdmin/saga";
import HomeGroupsStaffSaga from "./HomeGroupsStaff/saga";
import HomesSaga from "./Homes/saga";
import itemsSaga from "./Items/saga";
import LocationBlogsSaga from "./LocationBlogs/saga";
import NetworkSaga from "./Networking/saga";
import NewsSaga from "./News/saga";
import PackageSaga from "./Package/saga";
import PagesSaga from "./Pages/saga";
import PrintSaga from "./Print/saga";
import ResidenceSaga from "./Residence/saga";
import ReviewsSaga from "./Reviews/saga";
import ReviewSettingsSaga from "./ReviewSetting/saga";
import rolesSaga from "./Roles/saga";
import RoomSaga from "./Rooms/saga";
import SlickCareProfilesSaga from "./SlickCareProfiles/saga";
import SurveySaga from "./Survey/saga";
import TaskSaga from "./Task/saga";
import TOCSaga from "./TypesOfCare/saga";
import userSagas from "./Users/saga";
import WebsiteSaga from "./Website/saga";
import WebsiteEnquiriesSaga from "./WebsiteEnquiries/saga";

// Roster
import AISaga from "./AISlice/saga";
import AvailabilitySaga from "./Availability/saga";
import BudgetSaga from "./Budget/saga";
import DiscrepancySaga from "./Discrepancy/saga";
import EmployeeSaga from "./Employee/saga";
import EmployeeEditSaga from "./EmployeeEdit/saga";
import LeaveSaga from "./EmployeeLeave/saga";
import EmployeeOnboardSaga from "./EmployeeOnboard/saga";
import RosterRoleSaga from "./EmployeeRole/saga";
import RotaSaga from "./EmployeeRota/saga";
import ShiftSaga from "./EmployeeShifts/saga";
import FeedSaga from "./Feed/saga";
import FeedActionSaga from "./FeedAction/saga";
import CommentSaga from "./FeedComments/saga";
import FeedVotesSaga from "./FeedVotes/saga";
import FeedbackSaga from "./Feedback/saga";
import FieldSaga from "./Field/saga";
import FolderSaga from "./Folder/saga";
import FolderContentSaga from "./FolderContent/saga";
import HubBlogSaga from "./HubBlog/saga";
import NotificationSaga from "./Notification/saga";
import OnboardingSaga from "./Onboarding/saga";
import OnboardingRevisionSaga from "./OnboardingRevision/saga";
import RosterSaga from "./Roster/saga";
import RotaFiltersSaga from "./RotaFilters/saga";
import StatsSaga from "./Stats/saga";
import StepSaga from "./Step/saga";
import TeamSaga from "./Teams/saga";
import TerminalSaga from "./Terminals/saga";
import SheetSaga from "./Timesheet/saga";
import VisitorGateSaga from "./VisitorGate/saga";
import VisitorSaga from "./Visitors/saga";
import HourlyRateSaga from "./HourlyRate/saga";

// Residents
import ResidentSaga from "./Resident/saga";
import MealPullListSaga from "./MealPullList/saga";
import HandoverSaga from "./Handover/saga";
import DailyRecordsSaga from "./DailyRecords/saga";
import ActivityBoardSaga from "./ActivityBoard/saga";
import ChartBoardSaga from "./ChartBoard/saga";
import LibertyReviewSaga from "./LibertyReview/saga";
import HomeActivityPlannerSaga from "./HomeActivityPlanner/saga";
import PreSaga from "./ResidentPre/saga";
import ResidentPreAssessSaga from "./ResidentPreAssess/saga";
import ResidentNetworkSaga from "./ResidentNetwork/saga";
import ResidentAssessmentTemplateSaga from "./ResidentAssessmentTemplate/saga";
import ResidentToolsSaga from "./ResidentTools/saga";
import ResidentGovernanceSaga from "./ResidentGovernance/saga";
import ResidentAssessmentSaga from "./ResidentAssessment/saga";
import ResidentBodyMapSaga from "./ResidentBodyMap/saga";
import BodyRegionsSaga from "./BodyRegions/saga";
import ResidentWarningsSaga from "./ResidentWarnings/saga";
import ResidentMedicationSaga from "./ResidentMedication/saga";
import ResidentAppointmentSaga from "./ResidentAppointment/saga";
import ResidentEvaluationSaga from "./ResidentEvaluation/saga";
import SearchSaga from "./Search/saga";
import ResidentDocumentsSaga from "./ResidentDocuments/saga";
import OnboardingBuilderSaga from "./OnboardingBuilder/saga";
import ResidentVaccinationSaga from "./ResidentVaccination/saga";
import ResidentAllergySaga from "./ResidentAllergy/saga";
import MaintenanceSaga from "./Maintenance/saga";
import ObservationScheduleSaga from "./ObservationSchedule/saga";
import ResidentSummarySaga from "./ResidentSummary/saga";
import TransferPackSaga from "./TransferPack/saga";
import LocationRuleSaga from "./LocationRule/saga";
import LocationJourneyGraphSaga from "./LocationJourneyGraph/saga";
import DeviceSettingsSaga from "./DeviceSettings/saga";
import AiConversationsSaga from "./AiConversations/saga";
import SafeguardingReviewSaga from "./SafeguardingReview/saga";
import IncidentRecordSaga from "./IncidentRecord/saga";
import WoundReportSaga from "./WoundReport/saga";
import CarePlanAuditSaga from "./CarePlanAudit/saga";
import AICreditsSaga from "./AICredits/saga";
import DocumentDraftSaga from "./DocumentDraft/saga";
import AiSuggestionsSaga from "./AiSuggestions/saga";

export default function* rootSaga() {
  yield all([
    userSagas(),
    AuthSagas(),
    rolesSaga(),
    itemsSaga(),
    AlertSaga(),
    CareHomeGroupsSaga(),
    CarePlanTeamSaga(),
    CarePlanTaskSaga(),
    CarePlanEquipmentSaga(),
    ResidentGroupSaga(),
    CareRoundSaga(),
    CareRoundTypeSaga(),
    HomesSaga(),
    EnquiriesSaga(),
    NewsSaga(),
    FaqsSaga(),
    HomeGroupsAdminSaga(),
    PagesSaga(),
    SlickCareProfilesSaga(),
    HomeGroupsStaffSaga(),
    BlogsSaga(),
    ResidenceSaga(),
    TOCSaga(),
    LocationBlogsSaga(),
    WebsiteSaga(),
    RoomSaga(),
    SettingsSaga(),
    ReviewsSaga(),
    ContactSaga(),
    ReviewSettingsSaga(),
    PackageSaga(),
    AICreditsSaga(),
    DocumentDraftSaga(),
    AiSuggestionsSaga(),
    HistorySaga(),
    PrintSaga(),
    NetworkSaga(),
    TaskSaga(),
    SurveySaga(),
    BundlesSaga(),
    //
    RosterRoleSaga(),
    EmployeeSaga(),
    LeaveSaga(),
    ShiftSaga(),
    RotaSaga(),
    BudgetSaga(),
    SheetSaga(),
    RosterSaga(),
    WebsiteEnquiriesSaga(),
    HubBlogSaga(),
    DiscrepancySaga(),
    AvailabilitySaga(),
    TerminalSaga(),
    NotificationSaga(),
    TeamSaga(),
    FeedSaga(),
    FeedActionSaga(),
    CommentSaga(),
    FeedbackSaga(),
    FolderSaga(),
    FolderContentSaga(),
    StepSaga(),
    FieldSaga(),
    OnboardingSaga(),
    EmployeeOnboardSaga(),
    EmployeeEditSaga(),
    OnboardingRevisionSaga(),
    RotaFiltersSaga(),
    AISaga(),
    FeedVotesSaga(),
    StatsSaga(),
    VisitorSaga(),
    VisitorGateSaga(),
    HourlyRateSaga(),
    // Residents
    ResidentSaga(),
    MealPullListSaga(),
    HandoverSaga(),
    DailyRecordsSaga(),
    ActivityBoardSaga(),
    ChartBoardSaga(),
    LibertyReviewSaga(),
    HomeActivityPlannerSaga(),
    PreSaga(),
    ResidentPreAssessSaga(),
    ResidentNetworkSaga(),
    ResidentAssessmentTemplateSaga(),
    ResidentToolsSaga(),
    ResidentGovernanceSaga(),
    ResidentAssessmentSaga(),
    ResidentBodyMapSaga(),
    BodyRegionsSaga(),
    ResidentWarningsSaga(),
    ResidentMedicationSaga(),
    ResidentAppointmentSaga(),
    ResidentEvaluationSaga(),
    SearchSaga(),
    ResidentDocumentsSaga(),
    OnboardingBuilderSaga(),
    ResidentVaccinationSaga(),
    ResidentAllergySaga(),
    MaintenanceSaga(),
    ObservationScheduleSaga(),
    ResidentSummarySaga(),
    TransferPackSaga(),
    LocationRuleSaga(),
    LocationJourneyGraphSaga(),
    DeviceSettingsSaga(),
    AiConversationsSaga(),
    SafeguardingReviewSaga(),
    IncidentRecordSaga(),
    WoundReportSaga(),
    CarePlanAuditSaga(),
  ]);
}
